var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actionBox",on:{"click":function($event){return _vm.emitClickEvent($event)}}},[_c('div',{staticClass:"actionBg",class:[
      _vm.cssStyle,
      _vm.actionboxSmall ? 'actionBg-isSmall' : '',
      _vm.disabled ? 'actionBox-disabled' : ''
    ]},[_c('div',{staticClass:"actionText"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }